<div class="flex flex-col flex-auto min-w-0">
  <div class="flex flex-auto flex-col overflow-hidden">
    <div class="flex flex-col">
      <div class="flex items-start text-theme-gray">
        <a mat-button (click)="back()"> <mat-icon>keyboard_backspace</mat-icon> Back </a>
      </div>
      <div class="flex flex-row justify-between items-center px-6">
        <div class="text-h5 text-bold">New Dynamic Report</div>
        <div class="flex flex-row gap-4">
          <button mat-button type="button" (click)="back()">Cancel</button>
          <button mat-button color="primary" type="button" class="filter-btn" (click)="save()"><mat-icon class="mr-1">save</mat-icon>Save</button>
          <button mat-flat-button color="primary" type="button" (click)="saveExport()">
            <mat-icon class="text-white mr-1">published_with_changes</mat-icon>Save & Export
          </button>
        </div>
      </div>
    </div>
    <div class="relative flex flex-col flex-auto overflow-hidden scroll-smooth">
      <red-dynamic-report-general-form #dynamicReportGeneralFormComponent [reportTypes]="reportTypes"></red-dynamic-report-general-form>
    </div>
  </div>
</div>
